import {
	ConfigurationLabel,
	ConfigurationLabelValue,
	isConfigurationLabel,
	isPlatformConfiguration,
	LabelsExcludedFromDashboard,
	PlatformConfiguration
} from '../../../common/types/ConfigurationTypes';

export const extractAdditionalLabels = (platform: PlatformConfiguration): ConfigurationLabel[] => {
	if (!platform.ADDITIONAL_LABELS || !Array.isArray(platform.ADDITIONAL_LABELS)) {
		return [];
	}

	// Validate each label to ensure type safety
	return platform.ADDITIONAL_LABELS.filter(isConfigurationLabel);
};

export const extractCoreLabels = (platform: PlatformConfiguration): ConfigurationLabel[] => {
	if (!platform.CORE_LABELS || !Array.isArray(platform.CORE_LABELS)) {
		return [];
	}

	// Validate each label to ensure type safety
	return platform.CORE_LABELS.filter(isConfigurationLabel);
};

export const isValidPlatformConfiguration = (
	platform: unknown
): platform is PlatformConfiguration => {
	return isPlatformConfiguration(platform);
};

export const processPlatformConfiguration = (
	platform: unknown
): {
	additionalLabels: ConfigurationLabel[];
	coreLabels: ConfigurationLabel[];
	isValid: boolean;
} => {
	if (!isValidPlatformConfiguration(platform)) {
		return {
			additionalLabels: [],
			coreLabels: [],
			isValid: false
		};
	}

	const additionalLabels = extractAdditionalLabels(platform);
	const coreLabels = extractCoreLabels(platform);

	return {
		additionalLabels,
		coreLabels,
		isValid: true
	};
};

export const buildLabelsExcludedFromDashboard = (
	coreLabels?: ConfigurationLabel[]
): LabelsExcludedFromDashboard => {
	if (!coreLabels?.length) {
		return {};
	}

	const labelsExcludedFromDashboard: LabelsExcludedFromDashboard = {};

	coreLabels.forEach((label) => {
		const excludedValues = (label.values ?? []).filter(
			(v): v is ConfigurationLabelValue =>
				typeof v === 'object' &&
				!!v &&
				(v as ConfigurationLabelValue).excludedFromDashboard === true
		) as ConfigurationLabelValue[];

		if (excludedValues.length > 0) {
			labelsExcludedFromDashboard[label.label] = excludedValues.map((ev) => ({
				value: ev.value,
				label: ev.value
			}));
		}
	});

	return labelsExcludedFromDashboard;
};
